import React, { useEffect, useState } from "react";
import "./AddRoleModal.css";
import { getSidebarAPI } from "../../../utils/APIs/sidebar";
import { AddRoleAPI } from "../../../utils/APIs/RoleApis";
import Loader from "../../../Loader/Loader";
import { toast } from "react-toastify";

const AddRoleModal = ({ isOpen, onClose, refreshData }) => {
  const [sidebarItems, setSidebarItems] = useState([]);
  const [permissions, setPermissions] = useState({});
  const [roleName, setRoleName] = useState("");
  const [description, setDescription] = useState("");

  const [loading, setLoading] = useState(false);

  // ✅ Fetch sidebar items
  useEffect(() => {
    const fetchSidebar = async () => {
      try {
        setLoading(true);
        const res = await getSidebarAPI();

        const items = res?.data?.data || [];

        setSidebarItems(items);

        // initialize permissions object
        const initialPermissions = {};
        items.forEach((item) => {
          initialPermissions[item.name] = false;
        });

        setPermissions(initialPermissions);
      } catch (err) {
        console.error("Sidebar fetch failed", err);
      } finally {
        setLoading(false);
      }
    };

    if (isOpen) {
      fetchSidebar();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const allSelected =
    Object.keys(permissions).length > 0 &&
    Object.values(permissions).every(Boolean);

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    const updated = {};
    Object.keys(permissions).forEach((key) => {
      updated[key] = checked;
    });
    setPermissions(updated);
  };

  const handleChange = (item) => {
    setPermissions({
      ...permissions,
      [item]: !permissions[item],
    });
  };

const handleSave = async () => {
  const selectedPermissions = Object.keys(permissions).filter(
    (key) => permissions[key]
  );

 // Allow alphanumeric but must contain at least one letter
const roleNameRegex = /^(?=.*[A-Za-z])[A-Za-z0-9]+$/;

if (!roleName.trim()) {
  toast.error("Role name is required");
  return;
}

if (!roleNameRegex.test(roleName)) {
  toast.error(
    "Role name must be alphanumeric and contain at least one letter (numbers only not allowed)"
  );
  return;
}

  if (selectedPermissions.length === 0) {
    toast.error("Select at least one permission");
    return;
  }

  const payload = {
    roleName,
    description,
    permissions: selectedPermissions,
  };

  try {
    setLoading(true);
    const response=await AddRoleAPI(payload);
    if(response?.data?.success || response?.status===200){
      toast.success(response?.data?.message||"Role Added Successfully")
      onClose()
      refreshData()
    }
    else{
       toast.error(response?.data?.message||"Role Not Added,Please try again later!")
       
    }

    onClose();
  } catch (err) {
    console.error("Role creation failed", err);
  } finally {
    setLoading(false);
  }
};

const resetForm = () => {
  setRoleName("");
  setDescription("");

  const resetPermissions = {};
  sidebarItems.forEach((item) => {
    resetPermissions[item.name] = false;
  });

  setPermissions(resetPermissions);
};



if(loading){
  return<Loader/>
}

  return (
    <div className="add-role__backdrop">
      <div className="add-role__modal">
        <h3 className="add-role__title">Add New Role</h3>

        <div className="add-role__form-group">
          <label>Role Name</label>
          <input
            type="text"
            placeholder="Enter role name"
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
          />
        </div>

        <div className="add-role__form-group">
          <label>Description</label>
          <textarea
            placeholder="Enter description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div className="add-role__permissions">
          <label className="add-role__permissions-title">
            Permissions
          </label>

          {/* Select All */}
          <label className="add-role__checkbox select-all">
             <input
              type="checkbox"
              checked={allSelected}
              onChange={handleSelectAll}
            />
            <span>Select All</span>
           
          </label>

          <hr className="add-role__divider" />

          <div className="add-role__permissions-grid">
            {sidebarItems.map((item) => (
              <label key={item._id} className="add-role__checkbox">
                <input
                  type="checkbox"
                  checked={permissions[item.name] || false}
                  onChange={() => handleChange(item.name)}
                />
                <span>{item.name}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="add-role__actions">
          {/* <button className="add-role__btn-cancel" onClick={onClose}>
            Cancel
          </button> */}
          <button
            className="add-role__btn-cancel"
            onClick={() => {
              resetForm();
              onClose();
            }}
          >
              Cancel
          </button> 

          <button
            className="add-role__btn-save"
            onClick={handleSave}
            disabled={loading}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddRoleModal;
